const navLinks = [
  { label: '施設紹介', href: '#about' },
  { label: '設備・機器', href: '#system' },
  { label: '料金プラン', href: '#price' },
  { label: '無料体験', href: '#experience' },
  { label: 'アクセス', href: '#access' },
  { label: 'よくある質問', href: '#faq' },
];

const handleNavClick = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  return (
    <footer className="bg-[#1a1a3e] pt-14 pb-24 md:pb-14">
      <div className="px-6 lg:px-20 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-12 mb-12">
          {/* Logo & SNS */}
          <div className="flex flex-col gap-6">
            <img
              src="https://static.readdy.ai/image/faab8405af96b700637a376baf26c6c6/63a3b48bb43cc521cdf9dc975b536e3e.png"
              alt="Golph.club Suminoe"
              className="h-8 w-auto object-contain brightness-0 invert"
            />
            <p className="text-white/35 text-xs leading-relaxed max-w-xs">
              大阪市住之江区の完全貸切シミュレーションゴルフ施設。<br />
              UNEEKOR EYE XO2搭載・無人営業。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/golph.club/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white/15 text-white/50 hover:text-[#47d6d4] hover:border-[#47d6d4]/50 transition-all duration-200"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Nav */}
          <div>
            <p className="text-white/30 text-xs uppercase tracking-widest mb-5">Navigation</p>
            <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/50 hover:text-[#47d6d4] text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
            <p className="text-white/30 text-xs uppercase tracking-widest mb-3">Resources</p>
            <ul className="grid grid-cols-2 gap-3">
              <li><a href="/manual/" className="text-white/50 hover:text-[#47d6d4] text-sm transition-colors whitespace-nowrap"><i className="ri-book-open-line mr-1"></i>マニュアル</a></li>
              <li><a href="/manual/courses.html" className="text-white/50 hover:text-[#47d6d4] text-sm transition-colors whitespace-nowrap"><i className="ri-flag-line mr-1"></i>収録コース</a></li>
              <li><a href="/manual/video.html" className="text-white/50 hover:text-[#47d6d4] text-sm transition-colors whitespace-nowrap"><i className="ri-play-circle-line mr-1"></i>使い方動画</a></li>
              <li><a href="/news/" className="text-white/50 hover:text-[#47d6d4] text-sm transition-colors whitespace-nowrap"><i className="ri-news-line mr-1"></i>ニュース</a></li>
              <li><a href="/sitemap/" className="text-white/50 hover:text-[#47d6d4] text-sm transition-colors whitespace-nowrap"><i className="ri-sitemap-line mr-1"></i>サイトマップ</a></li>
            </ul>
          </div>

          {/* CTA */}
          <div className="flex flex-col gap-3">
            <a
              href="https://tdbs.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-[#47d6d4] text-white font-bold px-7 py-3 rounded-full text-sm hover:bg-[#3bc4c2] transition-all duration-200 whitespace-nowrap"
            >
              予約する
            </a>
            <a
              href="https://lin.ee/IX2y4CH"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center border border-white/20 text-white/60 font-medium px-7 py-3 rounded-full text-xs hover:bg-white/5 transition-all duration-200 whitespace-nowrap"
            >
              無料体験を申し込む
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-7 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="text-white/25 text-xs">
            &copy; Golph.club / TANAKADAISUKE LTD. All Rights Reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/25 hover:text-white/50 text-xs transition-colors">特定商取引法に基づく表記</a>
            <a href="#" className="text-white/25 hover:text-white/50 text-xs transition-colors">お問い合わせ</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
